<a class="wwf-card" magic [magicCss]="{type:'square'}" [style.background]="'url('+api.getImageUrl(card.image)+')'" (click)="targetUrl()">
  <div class="wwf-card--mask" role="img" [attr.aria-label]="card.name" [style.background]="'url('+api.getImageUrl(card.image)+')'" >
  </div>
  <div class="wwf-card--body" >
    <h4 class="wwf-card--title">{{card.title.es}}</h4>
   <!--  <h4 class="wwf-card--title" *ngIf="conf.type=='event'">{{card.title}}</h4>
    <h4 class="wwf-card--title" *ngIf="conf.type=='resource'">{{card.title}}</h4> -->
    <p class="wwf-card--tag ts-color-2">{{card.created_at}}</p>
  </div>
  <div class="wwf-card--btn ts-background-{{conf.color}}" *ngIf="conf.type!='resource'" >
    <svg xmlns="http://www.w3.org/2000/svg" width="40.001" height="40" viewBox="0 0 40.001 40">
      <path id="ver-mas" d="M17.5-7850v-17.5H0v-5H17.5V-7890h5v17.5H40v5H22.5v17.5Z" transform="translate(0 7890)"
        fill="#fff" />
    </svg>
  </div>
  <!-- <a class="wwf-card--btn ts-background-{{conf.color}}" *ngIf="conf.type=='resource'" href="{{card.link}}" >
    <svg xmlns="http://www.w3.org/2000/svg" width="31.429" height="40" viewBox="0 0 31.429 40">
      <g id="descarga" transform="translate(-80 -440)">
        <path id="Trazado_25" data-name="Trazado 25" d="M97.143,451.429v13.158l5.714-5.715,2.021,2.021-9.164,9.163-9.163-9.163,2.02-2.021,5.715,5.715V451.429H81.071A1.071,1.071,0,0,0,80,452.5v26.429A1.072,1.072,0,0,0,81.071,480h29.286a1.072,1.072,0,0,0,1.072-1.071V452.5a1.071,1.071,0,0,0-1.072-1.071Z" fill="#fff"/>
        <rect id="Rectángulo_84" data-name="Rectángulo 84" width="2.857" height="11.429" transform="translate(94.286 440)" fill="#fff"/>
      </g>
    </svg>
  </a> -->
</a>
